import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SharedModule } from '../../_shared/shared.module';

import { Country } from '../shared/country.model';
import { CountryModalService } from '../shared/country-modal.service';

@Component({
  selector: 'app-country-detail',
  templateUrl: './country-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CountryDetailComponent {
  constructor(private countryModalService: CountryModalService) {}

  @Input() country: Country;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private canceledCountry = new EventEmitter();

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.countryModalService.openCountryTranslation(this.country, language);
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    this.canceledCountry.emit();
  }
}
